import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { updateUserInfo, clearUserInfo, handleLogout } from '@twigeducation/ts-auth';
import { TSTLoginUrl } from '../../apps/Authentication/urls';
import authenticationConfig from '../../authenticationConfig';

const withAuthentication = (Wrapped) => {
    class AuthenticationFlow extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                redirect: false,
            };

            this.isUserAuthenticated = this.isUserAuthenticated.bind(this);
            this.isUserAuthorized = this.isUserAuthorized.bind(this);
            this.logoutAndClearUserInfo = this.logoutAndClearUserInfo.bind(this);
        }

        componentWillReceiveProps(nextProps) {
            const previous = this.props.isUserLoggedIn;
            const next = nextProps.isUserLoggedIn;

            const authenticationChanged = previous !== next;

            if (authenticationChanged) {
                this.navigateToNextStep(next);
            } else {
                this.setState({ redirect: false });
            }
        }

        navigateToNextStep(isLoggedIn) {
            const nextUrl = isLoggedIn ? authenticationConfig.redirects.authorized : TSTLoginUrl;
            if (nextUrl !== this.state.redirect) {
                this.setState({ redirect: nextUrl });
            } else {
                this.setState({ redirect: false });
            }
        }

        isUserAuthenticated() {
            return this.props.isUserLoggedIn;
        }

        isUserAuthorized() {
            return this.isUserAuthenticated();
        }

        logoutAndClearUserInfo() {
            handleLogout();
            this.props.clearUserInfoAction();
        }

        render() {
            const { redirect } = this.state;
            if (redirect) {
                return <Redirect to={redirect} />;
            }

            return (
                <Wrapped
                  {...this.props}
                  logout={this.logoutAndClearUserInfo}
                  updateUserInfo={this.props.updateUserInfoAction}
                  isUserAuthorized={this.isUserAuthorized()}
                  isUserAuthenticated={this.isUserAuthenticated()}
                  loginUrl={TSTLoginUrl}
                />);
        }
    }

    AuthenticationFlow.propTypes = {
        clearUserInfoAction: PropTypes.func.isRequired,
        updateUserInfoAction: PropTypes.func.isRequired,
        isUserLoggedIn: PropTypes.bool,
    };

    AuthenticationFlow.defaultProps = {
        isUserLoggedIn: false,
    };

    const mapStateToProps = state => ({
        isUserLoggedIn: Boolean(state.userInfo.id),
    });

    const mapDispatchToProps = {
        clearUserInfoAction: clearUserInfo,
        updateUserInfoAction: updateUserInfo,
    };

    const withStore = connect(mapStateToProps, mapDispatchToProps);

    return withStore(AuthenticationFlow);
};

export default withAuthentication;
